import { queryClient } from 'tools/tan-stack-query';

import type { OrderId } from 'shared/domain';

export function qkGetAllOrderDetail() {
  return ['orders', 'detail'];
}

export function qkGetOrderDetailById(orderId: OrderId) {
  return [...qkGetAllOrderDetail(), { orderId }] as const;
}

export function invalidateGetAllOrderDetail() {
  queryClient.invalidateQueries({ queryKey: qkGetAllOrderDetail() }).then();
}

export function invalidateGetOrderDetailById(orderId: OrderId) {
  queryClient.invalidateQueries(qkGetOrderDetailById(orderId)).then();
}
